export const FhirEpicEnv_Local = 'local';
export const FhirEpicEnv_Dev = 'dev';
export const FhirEpicEnv_Staging = 'staging';
export const FhirEpicEnv_Prod = 'prod';
export const FhirEpicEnvs = [FhirEpicEnv_Local, FhirEpicEnv_Dev, FhirEpicEnv_Staging, FhirEpicEnv_Prod];
//# sourceMappingURL=types.js.map